'use strict';

module Patersons {

    export enum ResearchPublicationType {
        AustralianInvestor = <any>"AustralianInvestor",
        MorningMarket = <any>"MorningMarket",
        WeeklyMarketWrap = <any>"WeeklyMarketWrap"
    }

    export interface SubscribedResearchPublication {
        id: string;
        isSubscribed: boolean;
        name: string;
        description: string;
        enabled: boolean;
    }

    export class MyDetailsService extends BaseService {          
        
        getAccoladeOptions(): ng.IHttpPromise<any> {
            return this.get("/dataService/odata/accoladeoptions/Holdings.GetByUserId");
        };

        updateAccoladeOptions(accoladeOptions: AccoladeOptions): ng.IHttpPromise<AccoladeOptions> {
            return this.put("/dataService/odata/accoladeoptions(" + accoladeOptions.id + ")", accoladeOptions);
        };

        getResearchSubscriptions(): ng.IHttpPromise<any> {
            return this.get("/dataService/api/ResearchSubscriptions");
        };

        getResearchSubscription(publication: ResearchPublicationType): ng.IHttpPromise<any> {
            return this.get("/dataService/api/ResearchSubscriptions/" + publication);
        };
        
        updateResearchSubscriptions(data: SubscribedResearchPublication[]): ng.IHttpPromise<any> {
            return this.patch("/dataService/api/ResearchSubscriptions", data.reduce((acc, curr) => {
                if(curr.enabled){
                    acc[curr.id] = curr.isSubscribed
                }
                return acc
            }, {}));
        };
    }
}